import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-resolved-by-first-aid-modal',
  templateUrl: './resolved-by-first-aid-modal.component.html',
  styleUrls: ['./resolved-by-first-aid-modal.component.scss']
})
export class ResolvedByFirstAidModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  resolveByFirstAidForm!: FormGroup;
  submitted = false;

  constructor(
    private fb: FormBuilder,
    private api: SevaProfileService,
    protected dialogRef: NbDialogRef<any>
  ) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    this.initializeForm();
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
  }

  // Initialize the form with validation
  initializeForm() {
    this.resolveByFirstAidForm = this.fb.group({
      remarks: ['', [Validators.required]], // Validators for textarea
    });
  }

  // Function to handle the resolution action
  resolveByFirstAid() {
    if (this.resolveByFirstAidForm.invalid) {
      this.submitted = true;
      this.resolveByFirstAidForm.markAllAsTouched(); // Highlight invalid fields
      return;
    }
    this.submitted = false;

    const remarks = this.resolveByFirstAidForm.get('remarks')?.value;
    this.payload.FirstAidNotes = remarks;

    this.api
      .apiCall(this.endPoint, 'POST', this.payload)
      .subscribe((response: any) => {
        if (response.Data) {
          this.dialogRef.close(true); // Pass true to indicate success
        }
      });
  }

  // Function to cancel the modal
  cancel() {
    this.dialogRef.close(false); // Pass false to indicate cancellation
  }
}
